import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  frontlineQualifyingVolumeById,
  generation0VolumeById,
  orderingEntitiesById,
  qualifyingPointsById,
  totalGenerationVolumeById,
} from '/redux/selector/metric.performance.selector';
import {withProps} from '/util/selector.util';

import PersonalPerformanceSection from './PersonalPerformanceSection';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    currentUserCompetency: withCurrentUserCoachId(competencyById),
    frontlineQualifyingVolume: withCurrentUserCoachId(
      frontlineQualifyingVolumeById,
    ),
    generation0Volume: withCurrentUserCoachId(generation0VolumeById),
    totalGenerationVolume: withCurrentUserCoachId(totalGenerationVolumeById),
    orderingEntities: withCurrentUserCoachId(orderingEntitiesById),
    qualifyingPoints: withCurrentUserCoachId(qualifyingPointsById),
  }),
)(PersonalPerformanceSection);
